import { Box, Typography } from '@mui/material';
import LandingPageBlocks from '../../features/landingPage/components/LandingPageBlocks';
import { useAgency } from '../../hooks/useAgency';

const LandingPage: React.FC = () => {
  const { agency } = useAgency();

  if (!agency) return;

  return (
    <Box>
      <Typography variant='xxl'>Welcome, {agency.name}</Typography>
      <LandingPageBlocks />
    </Box>
  );
};

export default LandingPage;
